import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Compass, FolderKanban, ClipboardList, Menu } from 'lucide-react';

const NAV_ITEMS = [
  { path: '/dashboard', icon: LayoutDashboard, label: 'Start' },
  { path: '/briefing', icon: Compass, label: 'Mój Dzień' },
  { path: '/grant-monitor', icon: FolderKanban, label: 'Pipeline' },
  { path: '/tasks', icon: ClipboardList, label: 'Zadania' },
];

export default function MobileBottomNav({ onMenuToggle }: { onMenuToggle: () => void }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t z-50 md:hidden safe-area-bottom">
      <div className="flex items-center justify-around h-14">
        {NAV_ITEMS.map(item => {
          const active = location.pathname === item.path;
          return (
            <button key={item.path} onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center flex-1 h-full gap-0.5 transition ${
                active ? 'text-indigo-600' : 'text-gray-400'
              }`}>
              <item.icon size={20} />
              <span className="text-[10px] font-medium">{item.label}</span>
            </button>
          );
        })}
        <button onClick={onMenuToggle}
          className="flex flex-col items-center justify-center flex-1 h-full gap-0.5 text-gray-400">
          <Menu size={20} />
          <span className="text-[10px] font-medium">Menu</span>
        </button>
      </div>
    </nav>
  );
}
